import { Col } from "@amzn/stencil-react-components/layout";
import React, { FC } from "react";
import { getString } from "@/common/uistringlabels/ui-string-utils";
import type { PickupPhone } from "@/pages/Replacement/replacement.types";
import { CHOOSE_DELIVERY_STRINGS } from "../choose-delivery.constants";
import { PhoneNumberFields } from "./phone-number-fields";

const FIELD_PREFIX = "pickupPhone";
const GROUP_ID = `${FIELD_PREFIX}-group`;

export interface PickupPhonePanelProps {
  phone: PickupPhone;
  phoneCodes: string[];
  onChange: (phone: PickupPhone) => void;
}

export const PickupPhonePanel: FC<PickupPhonePanelProps> = ({ phone, phoneCodes, onChange }) => (
  <Col
    id={GROUP_ID}
    role="group"
    aria-label={getString(`${CHOOSE_DELIVERY_STRINGS}.pickupPhoneTitle`)}
    gridGap="S200"
    width="100%"
    data-testid="pickup-phone-panel"
  >
    <PhoneNumberFields
      phoneCodes={phoneCodes}
      countryCode={{
        testId: `${FIELD_PREFIX}-countryCode`,
        value: phone.phoneCountryCode,
        onChange: (phoneCountryCode) => onChange({ ...phone, phoneCountryCode }),
      }}
      phoneNumber={{
        testId: `${FIELD_PREFIX}-phoneNumber`,
        value: phone.phoneNumber,
        onChange: (phoneNumber) => onChange({ ...phone, phoneNumber }),
      }}
    />
  </Col>
);
